/* Live updater for INAYAH free-shipping progress bar.
   Polls /cart.js after any cart-modifying fetch and re-renders bar + message.
   Robust to the Minimog theme re-rendering the drawer (handler is idempotent).
*/
(function () {
  if (window.__INAYAH_FREESHIP_BOUND__) return;
  window.__INAYAH_FREESHIP_BOUND__ = true;

  function moneyFormat(cents, iso) {
    var dollars = (cents / 100);
    // USD format only; other currencies don't get a bar anyway.
    return '$' + dollars.toFixed(2);
  }

  function render(cart) {
    var bars = document.querySelectorAll('[data-inayah-freeship]');
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10) || 5000;
      var currency = bar.getAttribute('data-currency') || (cart.currency || 'USD');
      var current = cart.total_price || cart.items_subtotal_price || 0;
      var remaining = Math.max(0, threshold - current);
      var pct = Math.min(100, Math.round((current / threshold) * 100));

      var msg = bar.querySelector('[data-freeship-msg]');
      var fill = bar.querySelector('[data-freeship-fill]');

      if (currency !== 'USD') {
        if (msg) msg.innerHTML = 'Free shipping available on US orders over $50';
        if (fill) fill.style.width = '0%';
        return;
      }
      if (remaining <= 0) {
        if (msg) msg.innerHTML = '<strong>You&rsquo;ve unlocked FREE US shipping!</strong>';
        if (fill) fill.style.width = '100%';
      } else {
        if (msg) msg.innerHTML = 'You&rsquo;re <strong>' + moneyFormat(remaining) + '</strong> away from FREE US shipping';
        if (fill) fill.style.width = pct + '%';
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  // Patch fetch to catch any cart mutation the theme performs.
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0];
    var promise = origFetch.apply(this, args);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(function () { setTimeout(refresh, 200); }).catch(function () {});
    }
    return promise;
  };

  // Also patch XMLHttpRequest for any legacy ATC forms.
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__inayah_url = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener('load', function () {
      if (self.__inayah_url && /\/cart\/(add|change|update|clear)/.test(self.__inayah_url)) {
        setTimeout(refresh, 200);
      }
    });
    return origSend.apply(this, arguments);
  };

  // Theme custom events (Minimog fires these).
  ['cart:refresh', 'cart:updated', 'cart:change', 'product:added-to-cart'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 200); });
  });

  // Initial sync in case server-rendered values are stale.
  document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 500); });
})();
